import { List } from 'immutable';
import { investorGroupConstants } from '../constants';

export function investor_groups(state = {}, action) {
  switch (action.type) {
    case investorGroupConstants.INVESTOR_GROUP_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case investorGroupConstants.INVESTOR_GROUP_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case investorGroupConstants.INVESTOR_GROUP_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };

    case investorGroupConstants.INVESTOR_GROUP_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case investorGroupConstants.INVESTOR_GROUP_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case investorGroupConstants.INVESTOR_GROUP_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case investorGroupConstants.INVESTOR_GROUP_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case investorGroupConstants.INVESTOR_GROUP_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case investorGroupConstants.INVESTOR_GROUP_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const investorGroupIndex = state.items.findIndex(val => val.id == action.response.id);

      if (investorGroupIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(investorGroupIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case investorGroupConstants.INVESTOR_GROUP_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case investorGroupConstants.INVESTOR_GROUP_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case investorGroupConstants.INVESTOR_GROUP_DELETE_SUCCESS: {
      const { investorGroupId } = action;

      if (!state.items) {
        return state;
      }

      const investorGroupIndex = state.items.findIndex(val => val.id == investorGroupId);

      if (investorGroupIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(investorGroupIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case investorGroupConstants.INVESTOR_GROUP_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case investorGroupConstants.INVESTOR_GROUP_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
